module.exports = __webpack_public_path__ + "static/media/livraison.35490c82.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/livraison.png
// module id = 663
// module chunks = 0